//扩散圆材质
export default  `
vec4 drawCircle(vec2 pos, float radius, float width, float power, vec4 color)
{
    float dist1 = length(pos);
    dist1 = fract((dist1 * 5.0) - fract(time));
    float dist2 = dist1 - radius;
    float intensity = pow(radius / abs(dist2), width); 
    vec4 col = color.rgba * intensity * power * max((0.8- abs(dist2)), 0.0);
    return col;
}

vec3 hsv2rgb(float h, float s, float v)
{
    vec4 t = vec4(1.0, 2.0/3.0, 1.0/3.0, 3.0);
    vec3 p = abs(fract(vec3(h) + t.xyz) * 6.0 - vec3(t.w));
    return v * mix(vec3(t.x), clamp(p - vec3(t.x), 0.0, 1.0), s);
}

//--//
czm_material czm_getMaterial(czm_materialInput materialInput)
 {
    czm_material material = czm_getDefaultMaterial(materialInput);
    vec2 pos=2.0*materialInput.st-1.0; //中心位置
    float h = mix(1.0, 0.0, length(pos));
    //vec4 color_r = vec4(hsv2rgb(h, 1.0, 1.0), 1.0); //半径颜色
    vec4 color_r = vec4(color.r,color.g,color.b,color.a*h); //半径颜色
    float radius = 0.5;
    float width = 0.8;
    float power = 0.1;
    vec4 finalColor = drawCircle(pos, radius, width, power, color_r);
    //vec4 fragColor=mix(finalColor,color,0.25);
    material.diffuse = finalColor.rgb;
    material.alpha =finalColor.a;
    return material;
}`